<div class="title mb-4">
  <h2>Manage Marketplace</h2>
</div>

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'admin' }" (click)="selectMenu('admin')">Admin Shop</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'shop' }"
      (click)="selectMenu('shop'); getMemberShopProduct()">Member Shop Product</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'manage-category' }" (click)="selectMenu('manage-category')">
      Manage Category</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'sub-region' }" (click)="selectMenu('sub-region')">
      Manage Sub-Region</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'profile-char' }" (click)="selectMenu('profile-char')">Profile
      Character</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'super-admin' }" (click)="selectMenu('super-admin')">Super
      Admin</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'quests' }" (click)="selectMenu('quests')">Quests</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'template' }" (click)="selectMenu('template')">Product
      Template</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'member-certificate' }"
      (click)="selectMenu('member-certificate')">Member Certificate</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'member-keywords' }"
      (click)="selectMenu('member-keywords')">Member Keywords Search</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'member-email-template' }"
      (click)="selectMenu('member-email-template')">Manage Emails</a>
  </li>
</ul>
<section [ngStyle]="{ display: selMenu == 'admin' ? 'block' : 'none' }">

  <section class="ml-2 mt-3">
    Enable Testing Mode ( Disable Login Process ) <input type="radio" [(ngModel)]="modeEnable" name="Mode" class="ml-2"
      value="1"> Yes <input type="radio" [(ngModel)]="modeEnable" class="ml-2" name="Mode" value="0"> No
    <button type="button" class="btn btn-secondary ml-2" (click)="saveMode()">Save</button>
  </section>

  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="white_box shadow p-0">
        <div class="p-3 table-search">
          <i class="fa fa-search"></i>
          <input type="text" class="form-control" placeholder="Search by product or shop"
            (keyup)="searchProductShop($event.target.value)" />
        </div>

        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">
                <select2 [data]="data" ngx-infinite-scroll="true" displaySearchStatus="hidden" [(ngModel)]="value"
                  (update)="update()" (scroll)="onScroll()" placeholder="Shop">
                </select2>
                <div #dropdown class="ng-dropdown-panel" style="display: none"></div>
              </th>
              <th scope="col">Product</th>
              <th scope="col">Special Category</th>
              <th scope="col">Category</th>
              <th scope="col">Sub-Category</th>
              <th scope="col">Featured</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of product_list; let i = index">
              <th scope="row">{{ i + 1 }}</th>
              <td>
                <a [routerLink]="['/admin/shop']" [queryParams]="{ adminId: item.user.id }" class="text-dark">
                  <b>{{
                    shopNameArray[item.user.email]
                    }}</b>
                  {{ item.user.email }} <i class="fa-solid fa-edit"></i>
                </a>
              </td>
              <td>
                <a href="#" class="text-dark" (click)="editProductModal($event, editProduct, item.id)">{{ item.name }}
                  <i class="fa-solid fa-edit"></i></a>
              </td>
              <td>
                <select class="form-control" (change)="
                    onChangeSpecialCategory($event.target.value, item, i)
                  ">
                  <option value="#" selected>Select Special category</option>
                  <option *ngFor="
                      let cat of getUnselectedSpecialCategories(
                        item.special_category
                      )
                    " value="{{ cat }}">
                    {{ cat }}
                  </option>
                </select>
                <div class="chip-container mt-1">
                  <div class="chip" *ngFor="let cat of item.special_category">
                    <span class="chip-text">{{ cat }}</span>
                    <span class="close-btn" (click)="onChangeSpecialCategory(cat, item, i, false)"><i
                        class="fa fa-close"></i></span>
                  </div>
                </div>
              </td>

              <td>
                <select class="form-control" (change)="onChangeCategory($event.target.value, item.id)"
                  [(ngModel)]="item.marketplace_product.categoryId">
                  <option value="" selected>NULL</option>
                  <option *ngFor="let cat of categories" value="{{ cat.id }}">
                    {{ cat.name }}
                  </option>
                </select>
              </td>
              <td>
                <select class="form-control" (change)="onChangeSubcategory($event.target.value, item.id)"
                  [(ngModel)]="item.marketplace_product.subcategoryId">
                  <option value="" disabled>Select subcategory</option>
                  <option *ngFor="let cat of item.subcategories" value="{{ cat.id }}">
                    {{ cat.name }}
                  </option>
                </select>
              </td>
              <td class="text-right">
                <input type="checkbox" disabled *ngIf="
                    item.marketplace_product.categoryId == null ||
                    item.marketplace_product.subcategoryId == null
                  " />
                <input type="checkbox" (change)="featuredProduct(item.id)"
                  [(ngModel)]="item.marketplace_product.isFeatured" *ngIf="
                    item.marketplace_product.categoryId != null &&
                    item.marketplace_product.subcategoryId != null
                  " />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<section [ngStyle]="{ display: selMenu == 'shop' ? 'block' : 'none' }" class="mt-5">
  <app-add-shop #AddShop [enableMemberShop]="true" [enableMemberShopAdmin]="true"
    (shopUpdate)="shopUpdate($event)"></app-add-shop>
  <!-- Member Shop -->
  <section></section>

  <div class="table-responsive">
    <table class="table table-hover white_box shadow">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Phone</th>
          <th scope="col">
            <div class="d-flex">
              Product
              <input type="text" placeholder="Search" (keydown.enter)="handleSearchMemberShop($event)"
                class="form-control ml-1">
            </div>
          </th>
          <th scope="col">Status</th>
          <th scope="col">Category</th>
          <th scope="col">Sub-Category</th>
          <!-- <th scope="col">Current Sub-Region</th> -->
          <th scope="col">Sub-Region</th>
          <th scope="col" class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of memberShopProductList; let i = index">
          <th scope="row">{{ i + 1 }}</th>
          <td>{{ item?.appUser?.phone }}</td>

          <td>
            <a class="text-dark" (click)="
                editMemberShopProduct(item)">{{ item?.name | titlecase }} <i class="fa-solid fa-edit"></i></a>
          </td>
          <td>{{ item?.status }}</td>
          <td>
            <select class="form-control" (change)="
                onChangeMemberShopCategoryChange($event.target.value, item)
              ">
              <ng-container *ngFor="let c of memberShopCategories">
                <ng-container *ngIf="c?.subCategory.length == 0">
                  <option [value]="c?.id">{{ c?.name }}</option>
                </ng-container>
                <ng-container *ngIf="c?.subCategory.length > 0">
                  <optgroup [label]="c.name || 'No Category'">
                    <option [value]="t?.categorieChildId" [selected]="item.categoryId == t?.categorieChildId" *ngFor=" let
                      t of c?.subCategory">
                      {{ t?.categoryName }}
                    </option>
                  </optgroup>
                </ng-container>
              </ng-container>

              <!-- <option value="" selected>NULL</option>
              <option
                [selected]="item.categoryId == cat?.id"
                *ngFor="let cat of memberShopCategories"
                [value]="cat?.id + '|' + cat?.name"
              >
                {{ cat?.name | titlecase }}
              </option> -->
            </select>
          </td>
          <td>
            <select class="form-control" (change)="
                onChangeMemberShopSubCategoryChange($event.target.value, item)
              " [(ngModel)]="item.subCategoryName">
              <option value="" disabled>Select subcategory</option>
              <option *ngFor="let cat of memberShopSubcategories" [value]="cat.name + '|' + cat.region">
                {{ cat.region }}
              </option>
            </select>
          </td>
          <!-- <td>{{item?.subCategoryName}}</td> -->
          <td>
            <select class="form-control" (change)="updateMemberShopProductSubRegionId($event.target.value, item.id)
            " [(ngModel)]="item.subRegionId">
              <option value="" disabled>Select Sub-Region</option>
              <option *ngFor="let cat of subRegionList" [value]="cat.subRegionId">
                {{ cat.name }}
              </option>
            </select>

          </td>
          <td class="text-right">
            <section class="d-flex justify-content-center">
              <button class="btn btn-danger" (click)="deleteMemberShopProduct(item?.id)">
                Delete
              </button>
              <button class="btn btn-{{ item.isHidden ? 'success' : 'secondary' }} ml-2"
                (click)="handleHideProduct(item)">{{ item?.isHidden ? 'Unhide' : 'Hide' }}</button>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Member Shop -->
</section>
<!-- profile-char -->
<section [ngStyle]="{ display: selMenu == 'profile-char' ? 'block' : 'none' }" class="mt-2">
  <span><button class="btn btn-secondary mt-2" (click)="openProductCharForAddEdit(profileCharacter)">
      <i class="fa fa-plus-circle" aria-hidden="true"></i> Add
    </button></span>
  <table class="table table-hover white_box shadow" style="margin-top: 10px">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Image</th>
        <th scope="col">Name</th>
        <th scope="col">Description</th>
        <th scope="col">Category</th>
        <th scope="col">Status</th>
        <th scope="col">Price</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of allProfileCharacter; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td><img loading="lazy" style="height: 5rem" [src]="imgUrl + item.image" /></td>
        <td>{{ item?.name }}</td>
        <td>
          <span>{{ item?.description }}</span>
        </td>
        <td>{{ item?.category | titlecase }}</td>
        <td>{{ item?.status }}</td>
        <td>
          {{ item?.price || 0 }}
          <img loading="lazy" src="../../../assets/images/diamond.png" style="height: 20px; margin-right: 2px"
            class="rounded" />
        </td>
        <td class="text-right">
          <section class="d-flex justify-content-center">
            <button class="btn btn-info" (click)="openProductCharForAddEdit(profileCharacter, item)">
              <i class="fa fa-pencil" aria-hidden="true"></i>
              Edit
            </button>
            <button class="btn btn-secondary ml-2" (click)="openAssignProfile(assignProfileCharacter, item)">
              <i class="fa fa-users" aria-hidden="true"></i> Assign
            </button>
            <button class="btn btn-danger ml-2" (click)="deleteProductCharacter(item?.id)">
              <i class="fa fa-trash" aria-hidden="true"></i> Delete
            </button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>
<!-- profile-char -->
<!--super-admin-->
<section [ngStyle]="{ display: selMenu == 'super-admin' ? 'block' : 'none' }" class="mt-2">
  <app-super-admin> </app-super-admin>
</section>
<!--super-admin-->
<!--quests-->
<section [ngStyle]="{ display: selMenu == 'quests' ? 'block' : 'none' }" class="mt-2">
  <app-quests></app-quests>
</section>
<!--quests-->
<!--quests-->
<section [ngStyle]="{ display: selMenu == 'template' ? 'block' : 'none' }" class="mt-2">
  <product-template></product-template>
</section>

<section [ngStyle]="{ display: selMenu == 'member-certificate' ? 'block' : 'none' }" class="mt-2">
  <app-member-certificate></app-member-certificate>
</section>
<section [ngStyle]="{ display: selMenu == 'member-keywords' ? 'block' : 'none' }" class="mt-2">
  <app-member-keywords></app-member-keywords>
</section>
<!-- manage-category -->
<section *ngIf="selMenu == 'manage-category'" class="mt-2">
  <app-manage-category></app-manage-category>
</section>
<!-- manage-category -->
<!-- manage-SubRegion -->
<section *ngIf="selMenu == 'sub-region'" class="mt-2">
  <app-manage-sub-region></app-manage-sub-region>
</section>
<!-- manage-SubRegion -->
<!-- member-email-template -->
<section *ngIf="selMenu == 'member-email-template'" class="mt-2">
  <app-member-email-template></app-member-email-template>
</section>
<!-- member-email-template -->



<ng-template #editProduct let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between">
            <h3 class="mb-3">{{ formType }} Product</h3>
            <div class="form-group d-flex">
              <label for class="text-left pr-1">Unit</label>
              <input type="text" class="form-control per_val w-100" [(ngModel)]="unit" placeholder="Per Basket" />
            </div>

            <div class="form-group d-flex">
              <label for class="text-left pr-1">Rate</label>
              <div class="input-group mb-3 d-flex flex-nowrap">
                <input type="text" class="form-control per_val w-100"
                  (keyup)="updateFoodPercent($event.target.value, 1)" [(ngModel)]="percent_value" pattern="[0-9]*" />
                <div class="input-group-append">
                  <label class="input-group-text py-0" for="inputGroupSelect02">
                    <input type="checkbox" class="h-auto" (change)="updateFoodPercent($event.target.checked, 2)"
                      [(ngModel)]="percent_type" />
                  </label>
                </div>
              </div>
            </div>
            <div *ngIf="formType == 'Update'">
              <button class="com_btn add-review-btn px-2" (click)="show_add_review_modal(add_review_modal)">
                Add Review
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <form [formGroup]="editprodForm">
            <div class="row">
              <div class="col-md-7">
                <div class="form-group">
                  <label> Name </label>
                  <input type="text" formControlName="name" class="form-control" placeholder value />
                  <ng-container *ngIf="submitted && editproduct.name.errors">
                    <p class="error-message" style="padding: 0px; font-size: 12px"
                      *ngIf="editproduct.name.errors.required">
                      Product name is required!
                    </p>
                  </ng-container>
                </div>
                <div class="btn-group mb-2" style="overflow-x: auto">
                  <button (click)="isTabDescriptionActive = 1" class="btn btn-sm btn-{{
                      isTabDescriptionActive == 1 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-info-circle"></i> Description
                  </button>
                  <button (click)="isTabDescriptionActive = 2" class="btn btn-sm btn-{{
                      isTabDescriptionActive == 2 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-dollar-sign"></i> Charges
                  </button>
                  <button (click)="isTabDescriptionActive = 3" class="btn btn-sm btn-{{
                      isTabDescriptionActive == 3 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-truck"></i> Delivery
                  </button>
                </div>
                <div class="form-group d-{{
                    isTabDescriptionActive == 1 ? 'block' : 'none'
                  }}">
                  <textarea class="form-control" formControlName="descp" rows="14" placeholder></textarea>
                  <ng-container *ngIf="submitted && editproduct.descp.errors">
                    <p class="error-message" style="padding: 0px; font-size: 12px"
                      *ngIf="editproduct.descp.errors.required">
                      Product description is required!
                    </p>
                  </ng-container>
                </div>
                <div class="form-group d-{{
                    isTabDescriptionActive == 2 ? 'block' : 'none'
                  }}">
                  <textarea class="form-control" formControlName="charges" rows="14" placeholder></textarea>
                  <ng-container *ngIf="submitted && editproduct.charges.errors">
                    <p class="error-message" style="padding: 0px; font-size: 12px"
                      *ngIf="editproduct.charges.errors.required">
                      Product charges is required!
                    </p>
                  </ng-container>
                </div>
                <div class="form-group d-{{
                    isTabDescriptionActive == 3 ? 'block' : 'none'
                  }}">
                  <textarea class="form-control" formControlName="delivery" rows="14" placeholder></textarea>
                  <ng-container *ngIf="submitted && editproduct.delivery.errors">
                    <p class="error-message" style="padding: 0px; font-size: 12px"
                      *ngIf="editproduct.delivery.errors.required">
                      Product delivery is required!
                    </p>
                  </ng-container>
                </div>
              </div>
              <div class="col-md-5">
                <div class="btn-group mb-2" style="overflow-x: auto">
                  <button (click)="isTabDetailActive = 1" class="btn btn-sm btn-{{
                      isTabDetailActive == 1 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-image"></i> Main Image
                  </button>
                  <button (click)="isTabDetailActive = 2" class="btn btn-sm btn-{{
                      isTabDetailActive == 2 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-eye"></i> Seller Info
                  </button>
                  <button (click)="isTabDetailActive = 3" class="btn btn-sm btn-{{
                      isTabDetailActive == 3 ? 'dark' : 'light'
                    }}">
                    <i class="fa-solid fa-hashtag"></i> More Products
                  </button>
                </div>
                <div class="d-{{ isTabDetailActive == 1 ? 'block' : 'none' }}">
                  <div class="form-row">
                    <div class="form-group prod_upld col-md-6 col-6">
                      <input formControlName="image1" type="file" #file1 (change)="
                          onImageSelected1(file1.files, product, $event)
                        " accept="image/*" />
                      <img loading="lazy" *ngIf="food_image_1 == '' && food_image_1_url_show != 1"
                        src="../../../assets/images/uploadd2.png" class="food_img" />
                      <img loading="lazy" *ngIf="food_image_1 != '' && food_image_1_url_show != 1"
                        src="{{ imgUrl }}{{ food_image_1 }}" class="food_img" />
                      <img loading="lazy" src="{{ food_image_1_url }}"
                        *ngIf="food_image_1_url && food_image_1_url_show == 1" class="food_img" />
                    </div>
                    <div class="form-group prod_upld col-md-6 col-6">
                      <input formControlName="image2" type="file" #file2 (change)="
                          onImageSelected2(file2.files, product2, $event)
                        " accept="image/*" />
                      <img loading="lazy" *ngIf="food_image_2 == '' && food_image_2_url_show != 1"
                        src="../../../assets/images/uploadd2.png" class="food_img" />
                      <img loading="lazy" *ngIf="food_image_2 != '' && food_image_2_url_show != 1"
                        src="{{ imgUrl }}{{ food_image_2 }}" class="food_img" />
                      <img loading="lazy" src="{{ food_image_2_url }}"
                        *ngIf="food_image_2_url && food_image_2_url_show == 1" class="food_img" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group prod_upld col-md-6 col-6">
                      <input formControlName="image3" type="file" #file3 (change)="
                          onImageSelected3(file3.files, product3, $event)
                        " accept="image/*" />
                      <img loading="lazy" *ngIf="food_image_3 == '' && food_image_3_url_show != 1"
                        src="../../../assets/images/uploadd2.png" class="food_img" />
                      <img loading="lazy" *ngIf="food_image_3 != '' && food_image_3_url_show != 1"
                        src="{{ imgUrl }}{{ food_image_3 }}" class="food_img" />
                      <img loading="lazy" src="{{ food_image_3_url }}"
                        *ngIf="food_image_3_url && food_image_3_url_show == 1" class="food_img" />
                    </div>
                    <div class="form-group prod_upld col-md-6 col-6">
                      <input formControlName="image4" type="file" #file4 (change)="
                          onImageSelected4(file4.files, product4, $event)
                        " accept="image/*" />
                      <img loading="lazy" *ngIf="food_image_4 == '' && food_image_4_url_show != 1"
                        src="../../../assets/images/uploadd2.png" class="food_img" />
                      <img loading="lazy" *ngIf="food_image_4 != '' && food_image_4_url_show != 1"
                        src="{{ imgUrl }}{{ food_image_4 }}" class="food_img" />
                      <img loading="lazy" src="{{ food_image_4_url }}"
                        *ngIf="food_image_4_url && food_image_4_url_show == 1" class="food_img" />
                    </div>
                  </div>
                </div>

                <div class="d-{{ isTabDetailActive == 2 ? 'block' : 'none' }}">
                  <div class="form-group">
                    <div class="form-group">
                      <label> Chat URL </label>
                      <input type="text" formControlName="chat_url" class="form-control" placeholder value />
                    </div>
                    <label> Seller Info </label>
                    <textarea class="form-control" formControlName="seller_info" rows="8" placeholder></textarea>
                  </div>
                  <div class>
                    <label> Add Category </label>
                  </div>
                  <div class="form-row">
                    <div class="form-group prod_upld_icon col-md-3 col-3"
                      (click)="show_add_icon_modal(add_icon_modal, item, i)" *ngFor="let item of icons; let i = index">
                      <img loading="lazy" src="../../../assets/images/uploadd3.png" />
                      <span class="text-center">{{ item.value }}</span>
                    </div>
                  </div>
                </div>

                <div class="d-{{ isTabDetailActive == 3 ? 'block' : 'none' }}">
                  <div class="form-group">
                    <label>More Products</label>

                    <select2 [data]="moreProductsSelect" [multiple]="true" [displaySearchStatus]="always"
                      ngDefaultControl formControlName="more_products">
                    </select2>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="col-md-12 mt-3">
          <form [formGroup]="editprodForm">
            <div class="mt-3" style="text-align: center">
              <h5>Variations</h5>
            </div>

            <div class formArrayName="ingredientsEdit">
              <div class="row" *ngFor="
                  let ingredientEdit of editprodForm.get('ingredientsEdit')[
                    'controls'
                  ];
                  let i = index
                " [formGroupName]="i">
                <div class="form-group col-md-2">
                  <label> Name {{ i == 0 ? "(Main)" : "" }} </label>
                  <input type="text" formControlName="weight" class="form-control" placeholder />
                  <ng-container *ngIf="
                      submitted &&
                      editproduct.ingredientsEdit.controls[i].controls.weight
                        .errors
                    ">
                    <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="
                        editproduct.ingredientsEdit.controls[i].controls.weight
                          .errors.required
                      ">
                      Name is required!
                    </p>
                  </ng-container>
                </div>
                <div class="form-group col-md-4">
                  <label> Remarks </label>
                  <input type="text" formControlName="nprice" class="form-control" placeholder />
                  <!-- <ng-container *ngIf="submitted && editproduct.ingredientsEdit.controls[i].controls.nprice.errors">
                      <p class="error-message" style="padding: 0px; font-size: 12px"
                        *ngIf="editproduct.ingredientsEdit.controls[i].controls.nprice.errors.required">
                        N-Member Price is required!
                      </p>
                    </ng-container> -->
                </div>
                <div class="form-group col-md-2">
                  <label> Price </label>
                  <input type="text" formControlName="price" class="form-control" placeholder />
                  <ng-container *ngIf="
                      submitted &&
                      editproduct.ingredientsEdit.controls[i].controls.price
                        .errors
                    ">
                    <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="
                        editproduct.ingredientsEdit.controls[i].controls.price
                          .errors.required
                      ">
                      Member Price is required!
                    </p>
                  </ng-container>
                </div>
                <div class="form-group col-md-2">
                  <label> Cost Price </label>
                  <input type="text" formControlName="costPrice" class="form-control" placeholder />
                  <!-- <ng-container *ngIf="submitted && editproduct.ingredientsEdit.controls[i].controls.costPrice.errors">
                      <p class="error-message" style="padding: 0px; font-size: 12px"
                        *ngIf="editproduct.ingredientsEdit.controls[i].controls.costPrice.errors.required">
                        Cost Price is required!
                      </p>
                    </ng-container> -->
                </div>
                <div class="form-group col-md-1 outofstock">
                  <label> Out Of Stock </label>
                  <input type="checkbox" formControlName="outOfStockSingle" class="form-control check_box_all"
                    (click)="checkSingleCheckboxes($event)" />
                </div>
                <div class="col-md-1 form-group">
                  <label> Action </label>
                  <i class="fas fa-trash-alt del_var_icon" (click)="removeIngredientEdit(i)"></i>
                </div>
              </div>
            </div>
            <div class="col-md-12 text-center add_cat_detail_variants">
              <a (click)="addIngredientEdit()"><i class="fa-solid fa-plus"></i></a>
            </div>
          </form>
        </div>
        <div class="col-md-12">
          <div class="text-center mt-3">
            <a (click)="editProd()" class="submit_prod"> Submit </a>&nbsp;
            <a (click)="modalService.dismissAll()" class="submit_prod cancel_button">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #add_review_modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Review</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body text-center">
    <di class="modal-body-container">
      <form (submit)="saveProductReview()" class="mt-n1">
        <div class="row" style="padding-top: 14px">
          <div class="col-md-12">
            <div class="nm_contact d-flex justify-content-center">
              <div class="form-group">
                <div class="d-flex justify-content-center">
                  <div class="img-circle d-flex justify-content-center align-items-center pointer"
                    (click)="openSelectImageDialog('#user-profile')">
                    <img loading="lazy" *ngIf="!imgBase64" src="../../../assets/images/uploadd3.png" class="food_img" />
                    <img loading="lazy" *ngIf="imgBase64" width="100%" height="100%" class="user-profile"
                      [src]="imgBase64" alt="" srcset="" />
                    <input type="file" id="user-profile" (change)="saveSeletedImage($event)" class="d-none"
                      accept="image/*" />
                  </div>
                </div>
                <div class="mt-4 row">
                  <label for="name" class="col-sm-3 col-form-label">User Name</label>
                  <div class="col-sm-12">
                    <input [(ngModel)]="productReview.userName" type="text" placeholder="Enter user name"
                      class="form-control" id="user_name" name="user_name" />
                  </div>
                </div>
                <div class="mb-3 row">
                  <label for="comment" class="col-sm-1 col-form-label">Comment</label>
                  <div class="col-sm-12">
                    <textarea placeholder="Enter Comment" [(ngModel)]="productReview.comment" id="comment"
                      name="comment" class="form-control"></textarea>
                  </div>
                </div>

                <div class="mb-3 row">
                  <label for="rating" class="col-sm-1 col-form-label">Rating</label>
                  <div class="col-sm-12">
                    <input [(ngModel)]="productReview.rating" type="number" placeholder="Enter rating (0 - 5)"
                      class="form-control" id="rating" min="0" max="5" name="rating" (input)="checkRating($event)" />
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="com_btn add-review-btn px-2" type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- <img loading="lazy"
          [src]="getImagePath(currentItem.image)"
          class="modal_sm_img"
          alt=""
        /> -->
    </di>
  </div>
</ng-template>
<ng-template #add_icon_modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Icon</h4>
    <a (click)="modal.dismiss('Cross click')" id="closeIconModal"><i class="fa fa-window-close"
        aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <form class="mt-n1">
      <div class="form-group">
        <label for="">Type</label>
        <select [(ngModel)]="focusIcon.value" (change)="handleTypeIcon()" [ngModelOptions]="{ standalone: true }"
          class="form-control">
          <option value="" selected disabled>Select Type</option>
          <option [value]="row" *ngFor="let row of focusIcon.dropdown">
            {{ row }}
          </option>
        </select>
      </div>
      <div class="form-group" *ngIf="focusIcon.showText">
        <label for="">Text</label>
        <textarea disabled rows="4" [ngModelOptions]="{ standalone: true }" [(ngModel)]="focusIcon.text"
          class="form-control"></textarea>
      </div>
      <div class="mt-3">
        <button class="btn btn-danger mr-2" (click)="saveIcon(true)">
          <i class="fa-solid fa-times"></i> Cancel
        </button>
        <button class="btn btn-primary" (click)="saveIcon()">
          <i class="fa-solid fa-save"></i> Save
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #profileCharacter let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class=""></div>
    <div class="modal-body">
      <div class="form-group col-12">
        <label for="exampleInputEmail1">Name</label>
        <input type="text" [(ngModel)]="profileCharacterName" class="form-control" id="exampleInputEmail1"
          aria-describedby="emailHelp" placeholder="Enter Name" />
      </div>

      <div class="form-group col-12">
        <label for="Description">Description</label>
        <textarea type="text" [(ngModel)]="profileCharacterDescription" class="form-control" id="Description" rows="5"
          aria-describedby="emailHelp" placeholder="Enter Description"></textarea>
      </div>

      <div class="form-group col-12">
        <label for="Description">Category</label>
        <select [(ngModel)]="profileCharacterCategory" class="form-control">
          <option value="" selected disabled>Select Category</option>
          <ng-container *ngFor="let i of profileCharacterType">
            <option [value]="i">{{ i | titlecase }}</option>
          </ng-container>
        </select>
      </div>
      <div class="form-group col-12">
        <label for="exampleInputEmail1">Price
          <img loading="lazy" src="../../../assets/images/diamond.png" style="height: 20px; margin-right: 2px"
            class="rounded" />
        </label>
        <input type="text" [(ngModel)]="profileCharacterPrice" class="form-control" id="exampleInputEmail1"
          aria-describedby="emailHelp" placeholder="Enter Price" />
      </div>
      <img loading="lazy" *ngIf="suggestionBase64" class="map-search-listing-img mt-2 product-char-image"
        [src]="suggestionBase64" alt="" />
      <img loading="lazy" *ngIf="selectedData?.image" class="map-search-listing-img mt-2 product-char-image"
        [src]="imgUrl + selectedData?.image" />

      <button class="com_btn px-1 month-list-add-more mt-3"
        (click)="openAttachImagePopupSugg('.suggestion-modal-pic-input')">
        <i class="fas fa-plus"></i> Upload Picture
      </button>
      <input type="file" #upload (change)="saveProductCharSelectedImage($event)"
        class="suggestion-modal-pic-input d-none" accept="image/*" />

      <div class="mt-3 text-right">
        <button class="btn btn-secondary mr-2" (click)="modalDismissAll()">
          <i class="fa-solid fa-times"></i> Cancel
        </button>
        <button class="btn btn-primary" (click)="saveProfileCharacter()">
          <i class="fa-solid fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #assignProfileCharacter let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-header">
      <h4 class="modal-title">Assign Profile Character</h4>
      <a (click)="modal.dismiss('Cross click')" id="closeIconModal"><i class="fa fa-window-close"
          aria-hidden="true"></i></a>
    </div>
    <div class="modal-body">
      <section class="mt-5">
        <section class="row flex justify-content-between ml-2 mr-2 mb-4">
          <div style="width: 80%">
            <ngx-slider [(value)]="currentValue" [(highValue)]="highValue" [options]="options"
              (userChange)="onLevelChange()"></ngx-slider>
          </div>
          <button type="button" class="btn btn-primary mr-3" (click)="assignProfileCharacterToMember()">
            <i class="fa fa-check-circle" aria-hidden="true"></i> Assign
          </button>
        </section>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">
                <input type="checkbox" value="" id="flexCheckDefault" /> Select
                All
              </th>
              <th scope="col" sortable="phone" (click)="onSort($event)">
                Member
              </th>
              <th scope="col" sortable="level" (sort)="onSort($event)">
                Level
              </th>
              <th scope="col" sortable="totalActiveTime" (sort)="onSort($event)">
                Total Active time
              </th>
              <th scope="col" sortable="noOfTimeLogin" (sort)="onSort($event)">
                No. of Time Login
              </th>
              <th scope="col" sortable="noOfReferrals" (sort)="onSort($event)">
                No. of Referrals
              </th>
              <th scope="col" sortable="noSuggestions" (sort)="onSort($event)">
                No. Suggestions
              </th>
              <th scope="col" sortable="noReports" (sort)="onSort($event)">
                No. Reports
              </th>
              <th scope="col" sortable="noForumPosts" (sort)="onSort($event)">
                No. Forum Posts
              </th>
              <th scope="col" sortable="noForumPosts" (sort)="onSort($event)">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let member of members; index as i">
              <tr *ngIf="members.length > 0">
                <td>
                  <input type="checkbox" [disabled]="member?.enableRemoveBtn" value="" id="flexCheckDefault"
                    (click)="selectMember(member, $event.target.checked)" [value]="member?.check" />
                </td>
                <td>
                  <a style="color: #009dff">{{ member?.phone }}</a>
                </td>
                <td>{{ member?.level || 0 }}</td>
                <td>{{ member?.totalSessionTimeInHr + " Hours" }}</td>
                <td>{{ member?.noOfTimeLogin }}</td>
                <td>{{ member?.noOfReferrals || 0 }}</td>
                <td>{{ member?.suggestions || 0 }}</td>
                <td>{{ member?.reports || 0 }}</td>
                <td>{{ member?.noForumPosts || 0 }}</td>
                <td>
                  <ng-container *ngIf="member?.enableRemoveBtn">
                    <button class="btn btn-info" (click)="
                        removeCharacterFromMember(member.enableRemoveBtn)
                      ">
                      <i class="fa fa-times" aria-hidden="true"></i> Remove
                      Character
                    </button>
                  </ng-container>
                </td>
              </tr>
            </ng-container>

            <tr *ngIf="members.length == 0">
              <td colspan="12" style="text-align: center">No Data</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between p-2">
          <ngb-pagination [collectionSize]="totalMembers.length" [(page)]="page" [pageSize]="pageSize"
            (pageChange)="nextPage()">
          </ngb-pagination>

          <select class="form-select" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="nextPage()">
            <option [ngValue]="10">10 items per page</option>
            <option [ngValue]="20">20 items per page</option>
            <option [ngValue]="30">30 items per page</option>
          </select>
        </div>
      </section>
    </div>
  </div>
</ng-template>